import { FlashMessage } from './../flash/models/flash-message';
import { Component, Input, Output, OnInit, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { OfferService } from 'app/offers/services/offer.service';
import { StrategyService } from 'app/strategies/services/strategy.service';
import { DialogRewardMoveComponent } from 'app/shared/components/dialog-reward-move/dialog-reward-move.component';
import { DialogConfirmComponent } from 'app/shared/components/dialog-confirm/dialog-confirm.component';
import { finalize } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import { orderBy } from 'lodash';

@Component({
  selector: 'app-card-offer-cpa',
  templateUrl: './card-offer-cpa.component.html',
  styleUrls: ['./card-offer-cpa.component.sass']
})
export class CardOfferCpaComponent implements OnInit {
  @Input() offer: any = {};
  @Input() strategy: any = {};

  phases: any = [];
  testPhases: any = [];
  defaultPhase: any = {}

  constructor(
    private offerService: OfferService,
    private strategyService: StrategyService,
    public dialog: MatDialog,
  ) { }

  ngOnInit() {
    this.loadEntities()
  }

  private loadEntities() {
    forkJoin([
      this.loadStrategyPhases(),
      this.loadOfferPhases()
    ])
      .pipe(
        finalize(() => { })
      )
      .subscribe((responses: any) => {
        let currentFound: any = {}
        let lastRate = 0

        let strategyPhases = responses[0].items
        const offerPhases = responses[1]
        const mergedPhases = offerPhases

        currentFound.cashback_rate = 0.0

        strategyPhases = strategyPhases.filter((item: any) => {
          if (item.start_date > this.offer.end_date || item.end_date < this.offer.start_date) {
            return false
          }

          return true
        })

        // merge offer and strategy phase lists

        strategyPhases.forEach((strategyPhase: any) => {
          let found = false

          offerPhases.map((offerPhase: any) => {
            if (offerPhase.strategy_phase_id === strategyPhase.id) {
              offerPhase.strategy = strategyPhase
              found = true
            }
            return offerPhase
          })

          if (!found) {
            let start_date = strategyPhase.start_date
            if (start_date < this.offer.start_date) {
              start_date = this.offer.start_date
            }
            let end_date = strategyPhase.end_date
            // if (!end_date || end_date > this.offer.end_date) {
            //   end_date = this.offer.end_date
            // }
            mergedPhases.push({
              strategy_phase_id: strategyPhase.id,
              start_date: start_date,
              end_date: end_date,
              strategy: strategyPhase,
            })
          }
        })

        // Order by start date

        this.phases = orderBy(mergedPhases, 'start_date')

        // Extract default phase

        this.phases = this.phases.filter((item: any) => {
          if (item.is_default) {
            this.defaultPhase = item
            item.is_current = false
            return false
          }

          return true
        })

        // Add phase properties

        this.phases = this.phases.map((phase, idx) => {
          // Is Current

          const phaseStartDate = new Date(phase.start_date).setUTCHours(0, 0, 0, 0)
          const phaseEndDate = new Date(phase.end_date).setUTCHours(0, 0, 0, 0)
          const currentDate = new Date().setUTCHours(0, 0, 0, 0)

          if (typeof phase.cashback_rate !== 'undefined' && phaseStartDate <= currentDate && phaseEndDate >= currentDate) {
            if (currentFound.cashback_rate <= phase.cashback_rate) {
              currentFound = phase
            }
          }

          // Arrow direction
          phase.is_first = (idx === 0)
          phase.is_last = (idx === this.phases.length - 1)
          phase.is_higher = lastRate < (phase.cashback_rate || phase.strategy?.playground?.max)
          phase.is_lower = lastRate > (phase.cashback_rate || phase.strategy?.playground?.max)
          phase.is_ended = phase.end_date && new Date(phase.end_date) < new Date()
          phase.is_next = !phase.is_ended && new Date(phase.start_date) >= new Date()

          lastRate = phase.cashback_rate || phase.strategy?.playground?.max

          return phase
        })

        currentFound.is_current = true

        if (this.phases.every((phase: any) => !phase.is_current)) {
          this.defaultPhase.is_current = true
        }

        setTimeout(() => {
          try {
            const $current = document.querySelector('.scope-phase--current')
            const $next = document.querySelector('.scope-phase--next')
            const $parent = document.querySelector('.scope-phases')
            const $phase = $current || $next

            const box = $phase.getBoundingClientRect()
            const parentBox = $parent.getBoundingClientRect()

            $parent.scrollTo({
              left: box.left - (parentBox.width / 2) - (box.width / 2) + 35,
              behavior: 'smooth'
            });
          } catch (e) { }
        }, 100);
      });
  }

  private loadStrategyPhases() {
    /**
     * No strategy available in case of offer status ENDED/COMPLETED/DEACTIVATED
     */
    return this.strategyService.fetchPhases(this.strategy ? this.strategy?.id : this.offer?.strategy_id)
  }

  private loadOfferPhases() {
    return this.offerService.fetchPhases(this.offer.id)
  }

  getPhaseIconClass(phase) {
    if (phase.is_end) {
      return 'i-arrow-end'
    }

    if (phase.is_higher) {
      return 'i-arrow-higher'
    }

    if (phase.is_lower) {
      return 'i-arrow-lower'
    }

    return 'i-arrow-equal'
  }

  isCompleted() {
    return ['ENDED', 'COMPLETED', 'DEACTIVATED'].includes(this.offer.status)
  }

  isAdjustable(phase) {
    if (this.isCompleted()) {
      return false
    }

    const startDate = new Date(phase.start_date).setUTCHours(0, 0, 0, 0)
    const currentDate = new Date().setUTCHours(0, 0, 0, 0)

    return startDate > currentDate
  }

  isEnded(phase) {
    if (!this.isAdjustable(phase)) {
      return true
    }

    if (!phase.end_date) {
      return false
    }

    const a = new Date(phase.end_date).setUTCHours(0, 0, 0, 0)
    const b = new Date().setUTCHours(0, 0, 0, 0)
    return a < b
  }

  isDeletable(phase, phases) {
    if (phases.length === 1) {
      return false
    }
    if (this.isCompleted()) {
      return false
    }

    if (!phase.cashback_rate) {
      return false
    }

    const a = new Date(phase.start_date).setUTCHours(0, 0, 0, 0)
    const b = new Date().setUTCHours(0, 0, 0, 0)

    return a > b
  }

  onAddPhase() {
    this.dialog.open(DialogRewardMoveComponent, {
      width: '750px',
      panelClass: "dialog-nopadding",
      data: {
        offer: this.offer,
        strategy: this.strategy,
        defaultPhase: this.defaultPhase
      }
    }).afterClosed().subscribe(confirm => {
      if (confirm) {
        this.loadEntities()
      }
    });
  }

  onDeletePhase(phase) {
    this.dialog.open(DialogConfirmComponent, {
      width: '400px',
      data: {
      }
    }).afterClosed().subscribe(confirm => {
      if (confirm) {
        this.offerService.deletePhase(this.offer.id, phase.id).subscribe(() => {
          this.loadEntities()
        })
      }
    });
  }

  onEditPhase(phase) {
    this.dialog.open(DialogRewardMoveComponent, {
      width: '750px',
      panelClass: "dialog-nopadding",
      data: {
        offer: this.offer,
        strategy: this.strategy,
        defaultPhase: this.defaultPhase,
        phase
      }
    }).afterClosed().subscribe(confirm => {
      if (confirm) {
        this.loadEntities()
      }
    });
  }
}
